import React, { useState } from "react";
import Minus from "images/Minus.svg";
import Plus from "images/Plus.svg";
import NcImage from "images/faq.png";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  isOpen,
  onToggle,
}) => {
  return (
    <div className=" my-4 rounded-xl">
      <button
        onClick={onToggle}
        className={`flex justify-between w-full space-x-4  py-6 px-4 rounded-lg text-left items-center ${
          isOpen ? "bg-white" : "bg-[#5A63AC33]"
        }`}
      >
        <span className="text-lg font-semibold leading-7 text-left text-[#121212]">
          {title}
        </span>
        <span>
          {isOpen ? (
            <svg
              width="57"
              height="140"
              viewBox="0 0 57 140"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="57"
                y="20"
                width="20"
                height="20"
                rx="10"
                transform="rotate(180 57 20)"
                fill="#FF0000"
              />
              <path
                d="M54.1421 10.2C54.1421 10.5556 54.0635 10.8444 53.9064 11.0667C53.7493 11.2889 53.545 11.4 53.2936 11.4H40.8485C40.5971 11.4 40.3928 11.2889 40.2357 11.0667C40.0785 10.8444 40 10.5556 40 10.2C40 9.84444 40.0785 9.55556 40.2357 9.33333C40.3928 9.11111 40.5971 9 40.8485 9H53.2936C53.545 9 53.7493 9.11111 53.9064 9.33333C54.0635 9.55556 54.1421 9.84444 54.1421 10.2Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                y="0.166504"
                width="20"
                height="20"
                rx="10"
                fill="#FF0000"
              />
              <path
                d="M10 5.1665C10.1778 5.1665 10.3222 5.22206 10.4333 5.33317C10.5444 5.44428 10.6 5.58873 10.6 5.7665V9.5665H14.4C14.5778 9.5665 14.7222 9.62206 14.8333 9.73317C14.9444 9.84428 15 9.98873 15 10.1665C15 10.3443 14.9444 10.4887 14.8333 10.5998C14.7222 10.7109 14.5778 10.7665 14.4 10.7665H10.6V14.5665C10.6 14.7443 10.5444 14.8887 10.4333 14.9998C10.3222 15.1109 10.1778 15.1665 10 15.1665C9.82222 15.1665 9.67778 15.1109 9.56667 14.9998C9.45556 14.8887 9.4 14.7443 9.4 14.5665V10.7665H5.6C5.42222 10.7665 5.27778 10.7109 5.16667 10.5998C5.05556 10.4887 5 10.3443 5 10.1665C5 9.98873 5.05556 9.84428 5.16667 9.73317C5.27778 9.62206 5.42222 9.5665 5.6 9.5665H9.4V5.7665C9.4 5.58873 9.45556 5.44428 9.56667 5.33317C9.67778 5.22206 9.82222 5.1665 10 5.1665Z"
                fill="white"
              />
            </svg>
          )}
        </span>
      </button>
      {isOpen && <div className="px-4 py-2">{children}</div>}
    </div>
  );
};

const FAQ: React.FC = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenSectionIndex(openSectionIndex === index ? null : index);
  };
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-14">
        <div className="">
          <div className="justify-center mb-8 text-left">
            <h2 className="text-4xl font-semibold">
              Frequently Asked Questions
            </h2>
          </div>
          <Section
            title="What is the minimum age requirement for renting?"
            isOpen={openSectionIndex === 1}
            onToggle={() => handleToggle(1)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              You must be 25 or older with a valid drivers license to rent.
            </span>
          </Section>

          <Section
            title="Is there a security deposit required?"
            isOpen={openSectionIndex === 3}
            onToggle={() => handleToggle(3)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              Yes, it will vary depending on the vehicle selected.
            </span>
          </Section>
          <Section
            title="Is there a minimum rental duration?"
            isOpen={openSectionIndex === 4}
            onToggle={() => handleToggle(4)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              Yes, depending on the vehicle selected it may vary between
              24-48hrs minimum.
            </span>
          </Section>
          <Section
            title="Do I need my own insurance to rent?"
            isOpen={openSectionIndex === 5}
            onToggle={() => handleToggle(5)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              For motorsport rentals, Yes. For exotics we offer insurance but
              you may want to make sure the coverages is what you would like,
              otherwise you may want to use your own insurance.
            </span>
          </Section>
        </div>
        <div className="flex flex-col space-y-10 justify-center">
          <img className="" src={NcImage} alt="" />
        </div>
      </div>
    </>
  );
};

export default FAQ;
